import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'

const modalsRoot = document.getElementById('root-modals') || document.body

const CountryDetailModal = ({show, handleClose, country, setCountry, onSubmit, onDelete, loading, error}) => {
  const updateData = fields => setCountry({...country, ...fields})

  return createPortal(
    <Modal
      id='country-detail-modal'
      aria-labelledby='country-detail-title'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={handleClose}
      backdrop={loading ? 'static' : true}
      keyboard={!loading}
    >
      <div className='modal-header'>
        <h2 id='country-detail-title'>{country?.id ? 'Update Country' : 'Create Country'}</h2>
      </div>
      <div className='modal-body py-lg-10 px-lg-10'>
        <form onSubmit={event => { event.preventDefault(); onSubmit() }}>
          {error && <div className='alert alert-danger' role='alert'>{error}</div>}
          <fieldset disabled={loading}>
            <div className='mb-10'>
              <label htmlFor='country-name' className='required fs-5 fw-semibold mb-2'>Country name</label>
              <input
                id='country-name'
                type='text'
                className='form-control form-control-lg form-control-solid'
                required
                value={country?.name || ''}
                onChange={event => updateData({name: event.target.value})}
              />
            </div>
            <div className='mb-10'>
              <label htmlFor='country-code' className='required fs-5 fw-semibold mb-2'>Country code</label>
              <input
                id='country-code'
                type='text'
                className='form-control form-control-lg form-control-solid'
                required
                maxLength={2}
                pattern='[A-Za-z]{2}'
                aria-describedby='country-code-help'
                value={country?.code || ''}
                onChange={event => updateData({code: event.target.value.toUpperCase()})}
              />
              <div id='country-code-help' className='form-text'>Two-letter country code (e.g. France: FR, Switzerland: CH)</div>
            </div>
            <div className='d-flex justify-content-between align-items-center gap-3'>
              <div>{country?.id && <button type='button' className='btn btn-lg btn-danger' onClick={onDelete}>Delete</button>}</div>
              <div className='d-flex gap-3'>
                <button type='button' className='btn btn-lg btn-light' onClick={handleClose}>Close</button>
                <button type='submit' className='btn btn-lg btn-primary'>
                  {loading ? 'Please wait...' : country?.id ? 'Update' : 'Create'}
                </button>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default CountryDetailModal
